<template>
  <div>
    <div class="shipping-address-select form-field-container" v-if="isLoggedIn && addresses.length > 0">
      <label>{{ $t('Select your address') }}</label>
      <checkout-address-select
        name="shipping-address-id"
        @change="(a) => this.selectedAddress = a"
        :addresses="addresses"
        :default-address="selectedAddress"
      ></checkout-address-select>
    </div>
    <checkout-address-form
      type="shipping"
      :postcode-validation-enabled="true"
      :is-logged-in="isLoggedIn"
      :is-business-account="isBusinessAccount"
      :key="addressFormKey"
      v-if="showForm"
    ></checkout-address-form>
  </div>
</template>

<script lang="ts">
  import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
  import ServiceContainer from '@flashpointbv/solar-service-container';

  @Component({
    name: 'checkout-address-shipping',
    components: {
      'checkout-address-form': ServiceContainer().getComponent('checkout-address-form'),
      'checkout-address-select': ServiceContainer().getComponent('checkout-address-select'),
    }
  })

  export default class extends Vue {
    @Prop({ required: false, default: false }) private isLoggedIn: boolean;
    @Prop({ required: false, default: false }) private isBusinessAccount: boolean;
    @Prop({ required: false, default: [] }) private addresses: Array<object>;

    private selectedAddress: object = {};

    @Watch('selectedAddress')
    handler(nv, ov): void {
      if (nv === ov) {
        return;
      }

      this.$store.dispatch('CheckoutAddress/setShippingAddress', {
        address: nv
      });

      if (nv['newAddress']) {
        this.$store.dispatch('CheckoutShipping/resetForAddressChange');
      }
    }

    private get addressFormKey(): string {
      if (this.selectedAddress['newAddress']) {
        return 'new';
      }

      return String(this.selectedAddress['entity_id'] || 'new');
    }

    private get shippingAddress(): object {
      return this.$store.getters['CheckoutAddress/shippingAddress'];
    }

    private get defaultShippingAddress(): object | null {
      return this.addresses.find((address) => address['default_shipping']) ?? null;
    }

    private get showForm(): boolean {
      return !this.isLoggedIn || this.addresses.length < 1 || (this.selectedAddress['newAddress'] || false);
    }

    created(): void {
      if (Object.keys(this.shippingAddress).length && window.location.hash !== '#login') {
        this.selectedAddress = this.shippingAddress
      } else if (null !== this.defaultShippingAddress) {
        this.selectedAddress = this.defaultShippingAddress;
      } else if (this.addresses.length) {
        this.selectedAddress = this.addresses[0];
      }

      if (Object.keys(this.selectedAddress).length) {
        this.$store.dispatch('CheckoutAddress/setShippingAddress', {
          address: this.selectedAddress
        });
      }
    }
  }
</script>
